import { MenuItem } from "src/components/atoms/MenuItem";
import * as S from "./MenuList.style";

interface MenuListProps {
  data: any;
}
export const MenuList = (props: MenuListProps) => {
  return (
    <S.MenuList>
      <S.MenuCategory>{props.data.category}</S.MenuCategory>
      <S.MenuItemList>
        {props.data.menu.map((item: any, idx: number) => {
          return <MenuItem key={idx} data={item} />;
        })}
      </S.MenuItemList>
    </S.MenuList>
  );
};
